import axios from 'axios';

const API_URL = 'https://backend.gouniquejourneys.co.uk/api/employee'; // Backend URL
const token = localStorage.getItem('token'); // Retrieve token

export const getGeneralQueries = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_URL}/queries/all-queries?page=${page}&limit=${limit}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Attach token
      },
      params: { page, limit }, // Passing query parameters
      
    });
    return response.data; // Returns { token, user }
  } catch (error) {
    throw error.response?.data?.message || 'Login failed';
  }
};

export const getSingleQuery = async (queryId) => {
  try {
    const response = await axios.get(`${API_URL}/queries/single-query/${queryId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching query:', error.response?.data || error.message);
    throw error;
  }
};

// Update a query (e.g., status, priority)
export const updateQuery = async (queryId, updatedData) => {
  try {
    const response = await axios.put(`${API_URL}/queries/update-query/${queryId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating query:', error.response?.data || error.message);
    throw error;
  }
};

// Add a new conversation to a query
export const addConversation = async (conversationData) => {
  try {
    const response = await axios.post(`${API_URL}/queries/add-conversation`, conversationData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding conversation:', error.response?.data || error.message);
    throw error;
  }
};

// Get all conversations related to a query
export const getAllConversations = async (queryId) => {
  try {
    const response = await axios.post(
      `${API_URL}/queries/get-conversation`,
      { queryId },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching conversations:', error.response?.data || error.message);
    throw error;
  }
};

// Get all admission queries assigned to an employee
export const getAssignedAdmissionQueries = async (currentPage, search, pageSize) => {
  try {
    const response = await axios.get(
      `${API_URL}/queries/assigned-admission-queries?page=${currentPage}&pageSize=${pageSize}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching assigned admission queries:', error.response?.data || error.message);
    throw error;
  }
};

// Get a single admission query by ID
export const getSingleAdmissionQuery = async (queryId) => {
  try {
    const response = await axios.get(`${API_URL}/queries/single-admission-query/${queryId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching admission query:', error.response?.data || error.message);
    throw error;
  }
};

// Update an admission query (e.g., status, priority)
export const updateAdmissionQuery = async (queryId, updatedData) => {
  try {
    const response = await axios.put(`${API_URL}/queries/update-admission-query/${queryId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating admission query:', error.response?.data || error.message);
    throw error;
  }
};

export const updateQueryAgent = async (bookingId, updatedData) => {
  try {
    const response = await axios.put(`${API_URL}/queries/update-query-agent/${bookingId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};
